export const startGame = ({ commit }, game) => {
  commit('setGame', game);
  commit('generateCards');
  commit('showDeck');
  commit('startTimer');
};

export const stopGame = ({ commit }) => {
  commit('stopTimer');
  commit('resetLevel');
  commit('showPreviousPage');
};

export const finishGame = ({ commit }) => {
  commit('stopTimer');
  commit('resetLevel');
  commit('showResult');
};
